import { cn } from '@/lib/utils';

type WordmarkProps = {
  className?: string;
  showName?: boolean;
  size?: 'sm' | 'md';
};

/**
 * Marque MiniShop — sceau argile/sauge avec "M" Fraunces italique.
 * Un seul point de vérité pour le logo dans toute l'app.
 */
export function Wordmark({ className, showName = true, size = 'md' }: WordmarkProps) {
  const seal = size === 'sm' ? 'h-8 w-8 text-base' : 'h-9 w-9 text-lg';
  const name = size === 'sm' ? 'text-lg' : 'text-xl';

  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span
        className={cn(
          'grid place-items-center rounded-2xl bg-primary text-white shadow-soft ring-1 ring-inset ring-white/10',
          seal,
        )}
        aria-hidden
      >
        <span className="font-display font-medium italic leading-none">M</span>
      </span>
      {showName && (
        <span className={cn('font-display font-medium tracking-tight text-ink', name)}>
          MiniShop
        </span>
      )}
    </span>
  );
}
